import { render, staticRenderFns } from "./TableControls.vue?vue&type=template&id=00aeff04&"
import script from "./TableControls.vue?vue&type=script&lang=js&"
export * from "./TableControls.vue?vue&type=script&lang=js&"
import style0 from "./TableControls.vue?vue&type=style&index=0&id=00aeff04&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00aeff04')) {
      api.createRecord('00aeff04', component.options)
    } else {
      api.reload('00aeff04', component.options)
    }
    module.hot.accept("./TableControls.vue?vue&type=template&id=00aeff04&", function () {
      api.rerender('00aeff04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/HotelPlanner/Components/TableControls.vue"
export default component.exports